import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { AutoresponderComponent } from 'src/app/components/autoresponder/autoresponder.component';
import { ChannelSelectorModule } from 'src/app/components/channel-selector/channel-selector.module';
import { SupportStepsModule } from 'src/app/components/support-steps/support-steps.module';
import { WorkingHoursModule } from 'src/app/components/working-hours/working-hours.module';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { AdminMicrosoftTeamsRoutingModule } from './admin-microsoft-teams-routing.module';
import { AdminMicrosoftTeamsComponent } from './admin-microsoft-teams.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AdminMicrosoftTeamsRoutingModule,
    NgxDatatableModule,
    SharedPipesModule,
    SupportStepsModule,
    NgxTippyModule,
    WorkingHoursModule,
    ChannelSelectorModule,
    AutoresponderComponent,
  ],
  declarations: [AdminMicrosoftTeamsComponent],
})
export class AdminMicrosoftTeamsModule {}
